import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";
import merge from "lodash/merge";

import { deadlineDatesToZonedTime } from "./deadlineDatesToZonedTime";
import { taskQueryKeys } from "./taskQueryKeys";

export const useInfiniteQueryTaskList = ({
  api,
  opts,
  tz,
}: {
  api: ApiType;
  tz: string;
  opts: Parameters<ApiType["taskApi"]["find"]>[0];
}) =>
  useInfiniteQuery({
    queryKey: taskQueryKeys.list(opts),
    queryFn: async ({ pageParam = 0 }: { pageParam?: number }) => {
      let parsedOpts = merge({}, opts, {
        extraParams: {
          ...opts.extraParams,
          page: pageParam,
        },
      });

      return (await api.taskApi.find(parsedOpts)).data;
    },
    getNextPageParam: (lastPage) =>
      lastPage.last ? undefined : lastPage.number + 1,
    select: (data) => ({
      ...data,
      pages: data.pages.map((page) => ({
        ...page,
        content: page.content.map((task) => ({
          ...task,
          ...deadlineDatesToZonedTime(task, tz),
        })),
      })),
    }),
    initialPageParam: undefined,
  });
